module.exports = __webpack_public_path__ + "static/media/8.94e26a1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/8.png
// module id = 643
// module chunks = 0